import {observer} from 'mobx-react-lite';
import {Link, useParams} from 'react-router-dom';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import {ConfirmPurchaseResponse} from '../../../entity/resource/confirm-purchase-response';
import {Box, Button, Card, CardContent, Divider, Typography} from '@mui/material';
import React, {useEffect, useState} from 'react';
import {useService} from '../../../infrastructure/service/service';
import LoadingComponent from '../components/widget/LoadingComponent';
import {BillingCallbackStatus} from '../../../entity/enums/billing-callback-status';
import DisabledByDefaultRoundedIcon from '@mui/icons-material/DisabledByDefaultRounded';

import '../../../assets/css/style.css';

const BillingCallback = (): JSX.Element => {
  const {userService, subscriptionService} = useService();
  const {status} = useParams();

  const [purchaseResult, setPurchaseResult] = useState<ConfirmPurchaseResponse>();
  const [isLoading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    const init = async (): Promise<void> => {
      if (status === BillingCallbackStatus.SUCCESS) {
        setLoading(true);

        const user = await userService.getCurrentUser();
        const urlParams = new URLSearchParams(window.location.search);
        const sessionIdParams = urlParams.get('session_id');

        if (sessionIdParams && user) {
          const response = await subscriptionService.confirmPurchase(user.organizationID ?? '', {sessionID: sessionIdParams});
          if (response)
            setPurchaseResult(response);
        }

        setLoading(false);
      }
    }
    init();
  }, []);

  if (isLoading)
    return <LoadingComponent title={'Processing your purchase...'}/>

  return (
    <>
      <Box className={'body-box subscription-callback-container'}>
        <Card elevation={0} className={'chart-card subscription-callback-card'}>
          <CardContent className={'subscription-callback-container description'}>
            {
              status === BillingCallbackStatus.SUCCESS
                ? <Box className={'subscription-callback-icon-container success'}>
                    <CheckCircleRoundedIcon className={'subscription-callback-icon success'}/>
                  </Box>
                  : <Box className={'subscription-callback-icon-container warning'}>
                    <DisabledByDefaultRoundedIcon className={'subscription-callback-icon warning'}/>
                  </Box>
            }
            <Typography id={'text-billing-status'} className={'subscription-callback-header'}>
              {
                status === BillingCallbackStatus.SUCCESS
                  ? 'Token Purchase Successful!'
                  : 'Payment Failed!'
              }
            </Typography>
            <Typography id={'text-billing-description'} className={'subscription-callback-description'}>
              {
                status === BillingCallbackStatus.SUCCESS
                  ? `Your token purchase has been processed successfully. ${purchaseResult?.tokensAdded} tokens have been added to your account.`
                  : 'Payment was not processed. Your request has not been completed.'
              }
            </Typography>
            <Box>
              {
                status === BillingCallbackStatus.SUCCESS
                  ? <Typography id={'text-billing-balance'} className={'subscription-callback-footer'}>
                      Your new token balance is: <strong>{purchaseResult?.balance} tokens</strong>
                    </Typography>
                  : <Typography id={'text-billing-balance'} className={'subscription-callback-footer'}>
                      Check your payment details and try again. If the issue persists, contact support for assistance.'
                    </Typography>
              }
            </Box>
            <Divider className={'subscription-callback-divider'}/>
            <Button
              id={'btn-billing-callback'}
              className={'zitles-button submit'}
              component={Link}
              to={'/grant-ai'}>
              Back to Grant AI
            </Button>
          </CardContent>
        </Card>
      </Box>
    </>
  );
}

export default observer(BillingCallback);
